<template>
  <div class="checkout-page"><NavBar />
  <div class="container checkout-main"><header class="checkout-heading"><span>SON ADIM</span><h1>Eğitimine bir adım kaldı.</h1><p>Ödeme ve fatura bilgilerini tamamlayarak eğitimine başlayabilirsin.</p></header><div v-if="packageLoading" class="alert alert-light border" role="status">Paket bilgileri güncelleniyor…</div><div v-else-if="!selectedPrice" class="alert alert-light border" role="alert">Paket bilgileri yüklenemedi. <button type="button" class="btn btn-light" @click="getPackage">Tekrar dene</button></div>
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="checkout-layout">
          <div class="checkout-body">
              <div class="row">
                <div class="col-12 col-lg-7 checkout-fields">
                  
                  <div class="section-heading"><i class="bi bi-credit-card"></i> Kart Bilgileri</div>

                  <div class="row gy-3">
                    <div class="col-md-6">
                      <label for="cc-name" class="form-label">Kart Üzerindeki İsim (*)</label>
                      <input id="cc-name" autocomplete="cc-name" type="text" class="form-control" v-model="cardHolderName" placeholder="Ad soyad" @input="maskCardHolderName">
                      <div class="invalid-feedback" :style="{'display':(cardHolderNameError)?'block':'none'}"  v-html="cardHolderNameError"></div>
                    </div>

                    <div class="col-md-6">
                      <label for="cc-number" class="form-label">Kart Numarası (*)</label>
                      <input id="cc-number" autocomplete="cc-number" inputmode="numeric" type="text" class="form-control" v-model="cardNumber" placeholder="0000-0000-0000-0000" @input="maskCardNumber" >
                      <div class="invalid-feedback" :style="{'display':(cardNumberError)?'block':'none'}"  v-html="cardNumberError"></div>
                    </div>

                    <div class="col-md-6">
                      <label for="cc-expiration" class="form-label">Son Kullanım Tarihi (*)</label>
                      <input id="cc-expiration" autocomplete="cc-exp" inputmode="numeric" type="text" class="form-control" v-model="cardExpireDate" placeholder="AA/YY" @input="maskExpireDate" >
                      <div class="invalid-feedback" :style="{'display':(expireError)?'block':'none'}"  v-html="expireError"></div>
                    </div>

                    <div class="col-md-6">
                      <label for="cc-cvv" class="form-label">CVV (*) <a href="javascript:;" id="tooltipButton" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="CVV, kredi kartınızın arkasındaki son üç hanedir."><i class="bi bi-info-circle"></i></a></label>
                      <input id="cc-cvv" autocomplete="cc-csc" inputmode="numeric" type="text" class="form-control" v-model="cardCvvNumber" placeholder="123"  @input="maskCardCvvNumber">
                      <div class="invalid-feedback" :style="{'display':(cardCvvNumberError)?'block':'none'}"  v-html="cardCvvNumberError"></div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-label">Taksit seçenekleri</div>
                      <div class="installment-options">
                        <div class="d-flex installment-option" v-for="n in selectPackage?.prices.filter(x=>x.installmentNumber==1 || x.installmentNumber==2 || x.installmentNumber==3 || x.installmentNumber==6 || x.installmentNumber==9 || x.installmentNumber==12)" :key="n.installmentNumber" :class="{'is-selected':selectInstallment == n.installmentNumber}">
                          <div class="pt-2 ps-2 pb-2">
                            <div class="form-check">
                              <input class="form-check-input" type="radio" :aria-label="n.installmentNumber == 1 ? 'Tek çekim' : n.installmentNumber + ' taksit'" v-model="selectInstallment" v-bind:id="'taksit'+n.installmentNumber" v-bind:value="n.installmentNumber">
                            </div>
                          </div>
                          <div style="cursor:pointer;" @click="selectInstallment=n.installmentNumber" class="pt-2 pe-2 pb-2 flex-grow-1" v-if="n.installmentNumber!=1" >{{n.installmentNumber}} x {{ priceFormat(n.installmentPrice) }} ₺</div>
                          <div style="cursor:pointer;" @click="selectInstallment=n.installmentNumber" class="pt-2 pe-2 pb-2 flex-grow-1" v-else>Tek Çekim {{ priceFormat(n.installmentPrice) }} ₺</div>
                          <div style="cursor:pointer;" @click="selectInstallment=n.installmentNumber" class="p-2 text-end"><span class="h6 d-block mb-0">{{ priceFormat(n.total) }} ₺</span><small class="fst-italic" v-if="n.description!=''">{{ n.description }}</small></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="invoice-heading">
                    <div class="d-flex justify-content-between">
                      <div class="section-heading">
                        <i class="bi bi-receipt"></i> Fatura Bilgileri
                      </div>
                      <div>
                        <div class="form-check form-switch">
                          <input class="form-check-input" type="checkbox" role="switch" v-model="bill.isCampanyInvoice" id="isCampanyInvoice">
                          <label class="form-check-label" for="isCampanyInvoice">Kurumsal Fatura</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row g-3">
                    <div class="col-sm-12" v-if="bill.isCampanyInvoice">
                      <label for="company-name" class="form-label">Firma Ünvanı (*)</label>
                      <input id="company-name" autocomplete="organization" type="text" class="form-control" v-model="bill.companyName" placeholder="Firma ünvanı" >
                      <div class="invalid-feedback" :style="{'display':(companyNameError)?'block':'none'}"  v-html="companyNameError"></div>
                    </div>

                    <div class="col-sm-6" v-if="!bill.isCampanyInvoice">
                      <label for="firstName" class="form-label">Ad (*)</label>
                      <input id="firstName" autocomplete="given-name" type="text" class="form-control" v-model="bill.firstname" placeholder="Ad">
                      <div class="invalid-feedback" :style="{'display':(firstnameError)?'block':'none'}"  v-html="firstnameError"></div>
                    </div>

                    <div class="col-sm-6" v-if="!bill.isCampanyInvoice">
                      <label for="lastName" class="form-label">Soyad (*)</label>
                      <input id="lastName" autocomplete="family-name" type="text" class="form-control" v-model="bill.lastname"  placeholder="Soyad">
                      <div class="invalid-feedback" :style="{'display':(lastnameError)?'block':'none'}"  v-html="lastnameError"></div>
                    </div>

                    <div class="col-12">
                      <label for="address" class="form-label">Adres (*)</label>
                      <input id="address" autocomplete="street-address" type="text" class="form-control" v-model="bill.address"  placeholder="Mahalle, sokak ve kapı numarası">
                      <div class="invalid-feedback" :style="{'display':(addressError)?'block':'none'}"  v-html="addressError"></div>
                    </div>

                    <div class="col-sm-6">
                      <label for="tax-number" class="form-label">Vergi Numarası / TC.Kim.No (*)</label>
                      <input id="tax-number" autocomplete="off" inputmode="numeric" type="text" class="form-control" maxlength="11" v-model="bill.taxNumber" placeholder="Vergi veya T.C. kimlik numarası">
                      <div class="invalid-feedback" :style="{'display':(taxNumberError)?'block':'none'}"  v-html="taxNumberError"></div>
                    </div>

                    <div class="col-sm-6" v-if="bill.isCampanyInvoice">
                      <label for="tax-office" class="form-label">Vergi Dairesi (*)</label>
                      <input id="tax-office" autocomplete="off" type="text" class="form-control" maxlength="50" v-model="bill.taxOffice" placeholder="Vergi dairesi">
                      <div class="invalid-feedback" :style="{'display':(taxOfficeError)?'block':'none'}"  v-html="taxOfficeError"></div>
                    </div>
                  </div>

                </div>
                <div class="col-12 col-lg-5 checkout-summary">
                  <div class="section-heading">Sipariş Özeti</div>

                  <div class="summary-content" >
                      <div class="summary-label">Eğitim Paketi</div>
                      <div class="package-category" v-html="selectPackage?.categoryTitle"></div>
                      <div class="package-title" v-html="selectPackage?.packageTitle"></div>

                      <div v-if="selectedPrice?.realDiscountPrice>0">
                          <div class="summary-label">İndirim Tutarı</div>
                          <div class="discount-amount">- {{priceFormat(selectedPrice?.realDiscountPrice)}} ₺</div>
                      </div>

                      <div class="summary-label">Toplam Tutar</div>
                      <div class="total-amount">{{priceFormat(selectedPrice?.total)}} ₺</div>
                      <div class="tax-note"><small>KDV dahildir</small></div>
                      <div class="package-benefits">
                        <p>Toplam {{selectPackage?.packageProperty.lessonCount}} adet ders</p>
                        <span v-if="selectPackage?.packageProperty.postpone>0" class="d-block">{{selectPackage?.packageProperty.postpone}} adet ders ertele hakkı</span>
                        <span v-if="selectPackage?.packageProperty.freezeLesson" class="d-block">{{ selectPackage?.packageProperty.freezeLesson }} adet ders dondurma hakkı</span>
                      </div>
                      <div class="input-group discount-input">
                        <input type="text" class="form-control" placeholder="İndirim kodu" aria-label="İndirim kodu" v-model="discountCode">
                        <button v-if="!isApplyDiscount" class="btn btn-primary" type="button" @click="ApplyDiscount()" :disabled="submitLoading || packageLoading || !selectedPrice">Uygula</button>
                        <button v-if="isApplyDiscount" class="btn btn-danger" type="button" @click="RemoveDiscount()" :disabled="submitLoading || packageLoading || !selectedPrice">Kaldır</button>
                      </div>
                      <div class="mb-2">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" aria-label="Sözleşmeleri ve koşulları kabul ediyorum" v-model="isConfirm">
                          <small><a href="#" class="fst-italic text-decoration-underline link-dark" @click.prevent="OpenLegalPanel('DistanceSellingContrat', 'Mesafeli Satış Sözleşmesi')">Mesafeli satış sözleşmesini</a>, <a href="https://lengedu.com/Legal/UserAgreement" @click.prevent="OpenLegalPanel('UserAgreement', 'Kullanım Sözleşmesi')" class="fst-italic text-decoration-underline link-dark">kullanım sözleşmesini</a>, <a href="https://lengedu.com/Legal/WarrantyDisclaimerAndCancellationRefundPolicy" @click.prevent="OpenLegalPanel('WarrantyDisclaimerAndCancellationRefundPolicy', 'Garanti, İptal ve İade Koşulları')" class="fst-italic text-decoration-underline link-dark">garanti, iptal ve iade koşullarını</a> okudum ve kabul ediyorum.</small>
                          <div class="invalid-feedback" :style="{'display':(isConfirmError)?'block':'none'}"  v-html="isConfirmError"></div>
                        </div>
                      </div>
                      <div class="d-grid gap-2">
                        <button type="button" class="btn btn-primary btn-lg" @click="PayCC()" :disabled="submitLoading || packageLoading || !selectedPrice"><span v-if="submitLoading" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>{{ submitLoading ? 'İşleniyor…' : 'Ödemeyi tamamla' }} <i class="bi bi-arrow-right" aria-hidden="true"></i></button><p class="payment-note"><i class="bi bi-shield-check" aria-hidden="true"></i> 3D Secure ile ödeme</p>
                      </div>

                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <MarketSellingContractModal 
    :Title="legalPanelTitle" :ContentKey="legalContentKey"
    :Visible="marketSellingContractModalVisible" 
    :Form="SellingContractForm"
    @CloseModal="OpenCloseMarketSellingContractModal($event)"
    />
  <FooterInPage /></div>
</template>

<script>
import {SetCookie} from "@/common/cookie-helper";
import { mapActions } from "vuex";
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'
import { Tooltip } from 'bootstrap';
import MarketSellingContractModal from '@/components/Market/MarketSellingContractModal.vue';
export default {
  name: 'MarketCheckoutPage',
  data() {
    return {
        bill:{
          isCampanyInvoice:false,
          companyName:'',
          firstname:'',
          lastname:'',
          address:'',
          taxNumber:'',
          taxOffice:''
        },
        cardHolderName:'',
        cardNumber:'',
        cardCvvNumber:'',
        cardExpireDate:'',
        expireError:'',
        cardCvvNumberError:'',
        cardHolderNameError:'',
        cardNumberError:'',

        companyNameError:'',
        firstnameError:'',
        lastnameError:'',
        addressError:'',
        taxNumberError:'',
        taxOfficeError:'',
        isConfirmError:'',
        submitLoading:false,
        isConfirm:false,
        selectInstallment:1,
        packageLoading:false,
        checkoutLogged:false,
        checkoutLogPending:false,
        selectPackage:null,
        discountCode:'',
        isApplyDiscount:false,
        marketSellingContractModalVisible:false, legalPanelTitle: 'Mesafeli Satış Sözleşmesi', legalContentKey: 'DistanceSellingContrat'
    };
  },
  components: {
    NavBar,
    FooterInPage,
    MarketSellingContractModal
  },
  computed:{ selectedPrice() { return this.selectPackage?.prices?.find(price => price.installmentNumber == this.selectInstallment); },
    SellingContractForm(){
      return {
        invoiceTitle:this.bill.isCampanyInvoice?this.bill.companyName:this.bill.firstname+' '+this.bill.lastname,
        invoiceAddress:this.bill.address,
        invoiceDate:Date.now(),
        phoneNumber:'',
        emailAddress:'',
        packageBeginDate:Date.now(),
        packageTitle: this.selectPackage?.categoryTitle+ ' '+ this.selectPackage?.packageTitle,
        packageAmount:this.priceFormat(this.selectedPrice?.total) +' ₺'
      }
    },
    CampaingCode(){
      let campaingCode = this.$route.query.campaingcode;
      if(campaingCode){
        return campaingCode;
      }
      return '';
    }
  },
  methods: {
    ...mapActions(["FindPackageAsync","GetGeneralContent","Payment","AddMarketEvent"]),
    maskCardNumber() {
      // Sadece rakamları tutar
      let onlyNumbers = this.cardNumber.replace(/\D/g, "");
      // Maksimum 16 karakter (rakamsal) sınırı uygular
      let maxNumbers = onlyNumbers.slice(0, 16);
      // Her 4 hanede bir boşluk ekler
      this.cardNumber = maxNumbers.replace(/(\d{4})(?=\d)/g, "$1-");
    },
    maskCardCvvNumber() {
      let onlyNumbers = this.cardCvvNumber.replace(/\D/g, "");
      this.cardCvvNumber = onlyNumbers.slice(0, 3);

      this.validateCvvNumber();
    },
    maskExpireDate() {
      let onlyNumbers = this.cardExpireDate.replace(/\D/g, ""); // Sadece rakamlar
      let maxNumbers = onlyNumbers.slice(0, 4); // En fazla 4 rakam

      if (maxNumbers.length >= 3) {
        this.cardExpireDate = maxNumbers.replace(/(\d{2})(\d{1,2})/, "$1/$2");
      } else {
        this.cardExpireDate = maxNumbers;
      }

      // Tarih doğrulama
      this.validateExpireDate();
    },
    maskCardHolderName() {
      this.cardHolderName = this.cardHolderName.replace(/[^a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g, "");
    },
    validateExpireDate() {
      let currentYear = new Date().getFullYear() % 100; // Son iki hane (YY)
      let currentMonth = new Date().getMonth() + 1; // Ay 0-indexed olduğundan +1

      if (!this.cardExpireDate) {
        this.expireError = ""; // Eğer expireDate boşsa hata yok
      }else if(this.cardExpireDate.length==2){
        let month = this.cardExpireDate;
        if (!month || month < 1 || month > 12) {
          this.expireError = "Geçerli bir ay giriniz (01-12).";
        } 
      }
      else if(this.cardExpireDate.length==5){
        let [month, year] = this.cardExpireDate.split("/").map(Number);
        if (!month || month < 1 || month > 12) {
          this.expireError = "Geçerli bir ay giriniz (01-12).";
        } else if (!year || year < currentYear || (year === currentYear && month < currentMonth)) {
          this.expireError = "Kartın son kullanma tarihi geçmiş.";
        } else {
          this.expireError = ''; 
        }
      }else if(this.cardExpireDate.length<5){
        this.expireError = "Geçerli bir tarih giriniz (mm/yy)."; 
      }
    },
    validateCvvNumber() {
      if (!this.cardCvvNumber) {
        this.cardCvvNumberError = ""; 
      }else if(this.cardCvvNumber.length<3){
          this.cardCvvNumberError = "CVV numarası 3 hane olmalıdır.";
      }else{
        this.cardCvvNumberError = "";
      }
    },
    
    validateExpireDateForSubmit(){
      if (!this.cardExpireDate) {
        this.expireError = "Son kullanım tarihi hatalı. (mm/yy)";
      }
      else
        this.validateExpireDate();
    },
    validateCvvNumberForSubmit(){
      if (!this.cardCvvNumber) {
        this.cardCvvNumberError = "Kartın CVV numarası hatalı."; 
      }else if(this.cardCvvNumber.length<3){
          this.cardCvvNumberError = "Kartın CVV numarası hatalı.";
      }else{
        this.cardCvvNumberError = "";
      }
    },
    validateCardHolderNameForSubmit(){
      if (!this.cardHolderName) {
        this.cardHolderNameError = "Kart sahibinin adı soyadı hatalı."; 
      }else if(this.cardHolderName.length<3){
          this.cardHolderNameError = "Kart sahibinin adı soyadı hatalı.";
      }else{
        this.cardHolderNameError = "";
      }
    },
    validateCardNumberForSubmit(){
      // Sadece rakamları tutar
      let onlyNumbers = this.cardNumber.replace(/\D/g, "");
      
      if (onlyNumbers.length!=16) {
        this.cardNumberError = "Kart numarası hatalı."; 
      }else{
        this.cardNumberError = "";
      }
    },
    validateCompanyNameForSubmit(){
      if(!this.bill.isCampanyInvoice){
        this.companyNameError = "";
        return;
      }

      if (!this.bill.companyName) {
        this.companyNameError = "Firma ünvanı hatalı."; 
      }else if(this.bill.companyName.length<3){
          this.companyNameError = "Firma ünvanı hatalı.";
      }else{
        this.companyNameError = "";
      }
    },
    validateFirstnameForSubmit(){
      if(this.bill.isCampanyInvoice){
        this.firstnameError = "";
        return;
      }

      if (!this.bill.firstname) {
        this.firstnameError = "Ad hatalı."; 
      }else if(this.bill.firstname.length<3){
          this.firstnameError = "Ad hatalı.";
      }else{
        this.firstnameError = "";
      }
    },
    validateLastnameForSubmit(){
      if(this.bill.isCampanyInvoice){
        this.lastnameError = "";
        return;
      }

      if (!this.bill.lastname) {
        this.lastnameError = "Soyad hatalı."; 
      }else if(this.bill.lastname.length<3){
          this.lastnameError = "Soyad hatalı.";
      }else{
        this.lastnameError = "";
      }
    },
    validateAddressForSubmit(){
      if (!this.bill.address) {
        this.addressError = "Adres hatalı."; 
      }else if(this.bill.address.length<3){
          this.addressError = "Adres hatalı.";
      }else{
        this.addressError = "";
      }
    },
    validateTaxNumberForSubmit(){
      if (!this.bill.taxNumber) {
        this.taxNumberError = "Vergi No / TC.Kim.No hatalı."; 
      }else if(this.bill.taxNumber.length<3){
          this.taxNumberError = "Vergi No / TC.Kim.No hatalı.";
      }else{
        this.taxNumberError = "";
      }
    },
    validateTaxOfficeForSubmit(){
      if(!this.bill.isCampanyInvoice){
        this.taxOfficeError = "";
        return;
      }

      if (!this.bill.taxOffice) {
        this.taxOfficeError = "Vergi dairesi hatalı."; 
      }else if(this.bill.taxOffice.length<3){
          this.taxOfficeError = "Vergi dairesi hatalı.";
      }else{
        this.taxOfficeError = "";
      }
    },
    validateIsConfirmForSubmit(){
      if (!this.isConfirm) {
        this.isConfirmError = "Mesafeli satış sözleşmesi, garanti, iptal ve iade koşullarını kabul edin."; 
      }else{
        this.isConfirmError = "";
      }
    },
    

    async getPackage(){
      this.packageLoading=true;
      await this.FindPackageAsync({
        categoryId:this.$route.params.catid,
        weeklyDay:'',
        duration: '',
        month: '',
        packageId: this.$route.params.id,
        discountCode:this.discountCode
      })
      .then((res)=>{
        this.selectPackage = res;
        if (!res.prices.some(plan => Number(plan.installmentNumber) === this.selectInstallment)) this.selectInstallment = 1;
        this.packageLoading=false;
        this.AddEventLog();
      })
      .catch(()=>{
        this.packageLoading=false
      });
    },
    priceFormat(value){
      if(value){
        return value.toLocaleString('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
      }
      return '0'.toLocaleString('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    },
    ApplyDiscount(){
      if(this.discountCode.length>3){
        this.isApplyDiscount=true;
        this.getPackage();
      }
    },
    RemoveDiscount(){
      this.discountCode='';
      this.isApplyDiscount=false;
      this.getPackage();
    },
    PayCC(){ if (this.submitLoading || this.packageLoading || !this.selectedPrice) return;
      this.submitLoading=true;
      let isValid = this.PayCCValidate();
      if(!isValid) {
        this.submitLoading=false;
        return;
      }
      let model = {
          platform: 2,
          form:{
            memberId:null
          },
          invoice:{
            id:null,
            title:this.bill.isCampanyInvoice?this.bill.companyName:this.bill.firstname+' '+this.bill.lastname,
            taxNumber : this.bill.taxNumber,
            taxOffice: this.bill.taxOffice,
            address:this.bill.address
          },
          productInfo: {
              productId: this.selectPackage.id,
              campaigns: this.selectPackage.campaingId==null?[]:[this.selectPackage.campaingId]
          },
          payment: {
              paymentType: 1,
              cardNumber: this.cardNumber,
              cardHolder: this.cardHolderName,
              cardExpireDate: this.cardExpireDate,
              cardCvv: this.cardCvvNumber,
              installment: this.selectInstallment,
              isThreeD: true,
              amount:this.selectedPrice?.total,
              currency:3
          }
      }

      this.SetReturnUrlForFaildPay();

      this.Payment(model)
      .then((result)=>{
         let threeDUrl = process.env.VUE_APP_PAYMENT_URL + '?q=' + result.paymentId;
         location.href = threeDUrl;
         this.submitLoading=false;
      })
      .catch(()=>{
       this.submitLoading=false;
      });

    },
    PayCCValidate(){
        this.validateCardHolderNameForSubmit();
        this.validateCardNumberForSubmit();
        this.validateExpireDateForSubmit();
        this.validateCvvNumberForSubmit();
        this.validateCompanyNameForSubmit();
        this.validateFirstnameForSubmit();
        this.validateLastnameForSubmit();
        this.validateAddressForSubmit();
        this.validateTaxNumberForSubmit();
        this.validateTaxOfficeForSubmit();
        this.validateIsConfirmForSubmit();

        if(this.cardHolderNameError!=''){
          return false;
        }

        if(this.cardNumberError!=''){
          return false;
        }

        if(this.expireError!=''){
          return false;
        }

        if(this.cardCvvNumberError!=''){
          return false;
        }

        if(this.companyNameError!=''){
          return false;
        }

        if(this.firstnameError!=''){
          return false;
        }

        if(this.lastnameError!=''){
          return false;
        }

        if(this.addressError!=''){
          return false;
        }

        if(this.taxNumberError!=''){
          return false;
        }

        if(this.taxOfficeError!=''){
          return false;
        }

        if(this.isConfirmError!=''){
          return false;
        }

        return true;
    },
    OpenLegalPanel(contentKey, title){
      this.legalContentKey = contentKey;
      this.legalPanelTitle = title;
      this.marketSellingContractModalVisible = true;
    },
    OpenCloseMarketSellingContractModal(visible){
      this.marketSellingContractModalVisible=visible;
    },
    SetReturnUrlForFaildPay(){
      let url = this.$route.fullPath;
      SetCookie('ReturnUrlForFailPayment',url,5);
    },
    async AddEventLog(){
      if (!this.selectPackage || this.checkoutLogged || this.checkoutLogPending) return;
      this.checkoutLogPending = true;
      let categoryId = this.$route.params.catid;
      let categoryName = this.selectPackage?.categoryTitle;
      let packageName = this.selectPackage?.packageTitle;
      let packageId = this.selectPackage.id;
      let event = 4;
      let description = '"'+categoryName+' / '+packageName+'" seçildi.';
      if(this.CampaingCode){
          description += ' (Kampanya Kodu : '+this.CampaingCode+')';
      }
      try {
        await this.AddMarketEvent({event:event,categoryId:categoryId,packageId:packageId,description:description});
        this.checkoutLogged = true;
      } catch {
        // A tracking failure must not prevent payment; a package reload can retry it.
      } finally {
        this.checkoutLogPending = false;
      }
    },
  },
  mounted: function() {
    const requestedInstallment = Number(this.$route.query.installment);
    if ([1, 2, 3, 6, 9, 12].includes(requestedInstallment)) this.selectInstallment = requestedInstallment;
    this.discountCode = String(this.CampaingCode || '');
    this.isApplyDiscount = !!this.discountCode;
    let tooltipTriggerEl = document.getElementById('tooltipButton');
    if (tooltipTriggerEl) {
      new Tooltip(tooltipTriggerEl);
    }
    this.getPackage();
  }
}
</script>
<style scoped>
.checkout-page { min-height: 100vh; background: #f7f9fb; color: #10243a; }
.checkout-main { max-width: 1120px; padding: 48px 24px 64px; }
.checkout-heading { margin-bottom: 32px; }
.checkout-heading > span { color: var(--brand-link); font-size: 11px; font-weight: 700; letter-spacing: 1.5px; }
.checkout-heading h1 { font-size: clamp(28px, 4vw, 38px); font-weight: 750; letter-spacing: -1.2px; margin: 12px 0; }
.checkout-heading p { color: #637489; font-size: 14px; line-height: 1.7; margin: 0; }
.checkout-body > .row { --bs-gutter-x: 24px; --bs-gutter-y: 24px; align-items: flex-start; }
.checkout-fields { padding: 28px; background: white; border: 1px solid #e0e6ed; border-radius: 20px; }
.checkout-summary { position: sticky; top: 24px; padding-left: 24px; }
.checkout-summary > .section-heading { background: white; border: 1px solid #e0e6ed; border-bottom: 0; border-radius: 20px 20px 0 0; padding: 28px 28px 0; margin: 0; }
.summary-content { background: white; border: 1px solid #e0e6ed; border-top: 0; padding: 24px 28px 28px; border-radius: 0 0 20px 20px; }
.section-heading { font-size: 18px; font-weight: 700; margin-bottom: 24px; }
.section-heading i { color: var(--brand-link); margin-right: 6px; }
.checkout-page .form-label { font-size: 12px; font-weight: 600; color: #46576b; margin-bottom: 8px; }
.checkout-page .form-control { min-height: 46px; border: 1px solid #dce3eb; border-radius: 10px; font-size: 13px; padding: 11px 12px; }
.checkout-page .form-control:focus { border-color: var(--brand-link); box-shadow: 0 0 0 3px #08795e15; }
.checkout-page .form-check-input:checked { background-color: var(--brand-link); border-color: var(--brand-link); }
.checkout-page .form-check-input:focus { border-color: var(--brand-link); box-shadow: 0 0 0 3px #08795e20; }
.installment-options { display: grid; gap: 8px; }
.installment-option { align-items: center; border: 1px solid #e5eaf0; border-radius: 10px; padding: 3px 5px; font-size: 13px; }
.installment-option.is-selected { background: #f1f9f5; border-color: #83b6a4; }
.installment-option .h6 { font-size: 13px; font-weight: 650; }
.installment-option small { font-size: 11px; color: #637489; }
.invoice-heading { margin: 28px 0 20px; padding-top: 26px; border-top: 1px solid #edf0f4; }
.invoice-heading > div { align-items: center; flex-wrap: wrap; gap: 12px; }
.invoice-heading .section-heading { margin: 0; }
.invoice-heading .form-check-label { font-size: 12px; color: #637489; }
.summary-label { font-size: 12px; color: #637489; margin-bottom: 6px; }
.package-category { font-size: 15px; font-weight: 600; overflow-wrap: anywhere; }
.package-title { font-size: 20px; font-weight: 700; margin: 5px 0 24px; overflow-wrap: anywhere; }
.discount-amount { color: var(--brand-link); font-weight: 650; margin-bottom: 18px; }
.total-amount { font-size: clamp(28px, 3vw, 34px); font-weight: 750; letter-spacing: -1px; overflow-wrap: anywhere; }
.tax-note { font-size: 12px; color: #8290a0; }
.package-benefits { display: grid; gap: 8px; border-top: 1px solid #edf0f4; border-bottom: 1px solid #edf0f4; margin: 22px 0; padding: 18px 0; font-size: 13px; color: #637489; }
.package-benefits p { margin: 0; color: #10243a; font-weight: 600; }
.discount-input { margin-bottom: 22px; }
.checkout-page .btn { border-radius: 10px; font-size: 13px; font-weight: 600; padding: 10px 16px; }
.checkout-page .btn-primary { background: var(--brand-link); border-color: var(--brand-link); }
.checkout-page .btn-primary:hover { background: #06634d; border-color: #06634d; }
.checkout-page .btn-danger { background: #fff5f5; border-color: #efd8d8; color: #b43f46; }
.checkout-page .btn-lg { padding: 14px 18px; margin-top: 16px; font-size: 14px; }
.summary-content .form-check small { display: block; font-size: 11px; line-height: 1.8; color: #637489; }
.summary-content .form-check a { color: #46576b !important; font-style: normal !important; }
.payment-note { display: flex; align-items: center; justify-content: center; gap: 6px; margin: 6px 0 0; font-size: 11px; color: #637489; }
.checkout-page a:focus-visible, .checkout-page button:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
@media (max-width: 991px) { .checkout-summary { position: static; padding: 0; } }
@media (max-width: 575px) { .checkout-main { padding: 30px 24px 40px; } .checkout-fields { padding: 20px; } .summary-content { padding: 20px; } .checkout-summary > .section-heading { padding: 20px 20px 0; } }
</style>
